import styled from 'styled-components';
// old design
export const TableHead = styled.thead `
  display: inline-block;
  width: 100%;
`;
// new design
export const TableHeadNew = styled.thead `
  display: inline-block;
  width: 100%;
  background-color: #ffd643;
  box-shadow: 0px 10px 7px rgba(26, 24, 20, 0.44);
`;
export const TableHeadModal = styled.thead `
  display: inline-block;
  width: 100%;
  height: 30px;
  background-color: transparent;
`;
